import * as Sentry from '@sentry/browser'
import { useEffect, useContext } from 'react'
import { AppContext } from 'contexts/AppProvider'
import { LANGUAGES, getLangIDbyLineLang } from 'helpers/language'
import { setUserIdAnalytics } from 'helpers/analytics'
import { getLiff } from 'helpers/liff'
import { setTokenSession } from 'helpers/localStorage'
import axios from 'axios'

import { initializeApp } from 'firebase/app'
import { getAuth, signInWithCustomToken } from 'firebase/auth'
import getFirebaseConfig from 'configs/firebase/firebaseConfig'
import { isDevelopment } from 'variables/environment'
import { changeLanguage } from 'i18next'

const firebaseConfig = getFirebaseConfig()

initializeApp(firebaseConfig)
const auth = process.env.REACT_APP_AUTH_FIREBAE === 'true' && getAuth()
const firebaseEndpoint = `${process.env.REACT_APP_API_HOSTNAME}/firebase/liff/custom-token`
const liff = getLiff()

function useGetLiffUser(liffId, onLiffInitialed = () => {}) {
  const {
    userProfile,
    setUserProfile,
    setUserEmail,
    setAccessToken,
    setLang,
    setIsLiffInit,
    isFacebookWebviewInit,
    isFacebookWebview,
  } = useContext(AppContext)

  const authWithLineAccessToken = async () => {
    if (!liff.isInClient() && isDevelopment) liff.login()
    const profile = await liff.getProfile()
    const lang = LANGUAGES.TH
    const accessToken = await liff.getAccessToken()
    setTokenSession(accessToken)
    const email = liff.getDecodedIDToken()?.email ? liff.getDecodedIDToken()?.email : ''
    setUserProfile(profile)
    setUserEmail(email)
    setAccessToken(accessToken)
    setUserIdAnalytics({ userProfile: profile })

    const selectedLang = getLangIDbyLineLang(lang)
    setLang(selectedLang)
    changeLanguage(selectedLang)
  }

  const authWithFirebaseCustomToken = async () => {
    const profile = await liff.getProfile()
    const lang = LANGUAGES.TH
    const accessToken = await liff.getAccessToken()
    axios.get(firebaseEndpoint, { headers: { Authorization: `Bearer ${accessToken}` } }).then((res) => {
      signInWithCustomToken(auth, res.data.token)
        .then((userCredential) => {
          const user = userCredential.user
          setUserProfile(profile)
          setAccessToken(user.accessToken)
          setUserIdAnalytics({ userProfile: profile })

          const selectedLang = getLangIDbyLineLang(lang)
          setLang(selectedLang)
          changeLanguage(selectedLang)
        })
        .catch((error) => {
          const errorCode = error.code
          const errorMessage = error.message
          console.log('errorCode: ', errorCode)
          console.log('errorMessage: ', errorMessage)
        })
    })
  }

  useEffect(() => {
    if (userProfile === '' && isFacebookWebviewInit && !isFacebookWebview && liffId) {
      liff
        .init({
          liffId,
          mock: isDevelopment,
        })
        .then(async () => {
          if (liff.isInClient() || liff.isLoggedIn()) {
            process.env.REACT_APP_AUTH_FIREBAE === 'true' ? authWithFirebaseCustomToken() : authWithLineAccessToken()
          } else {
            setLang(LANGUAGES.TH)
            changeLanguage(LANGUAGES.TH)
          }

          setIsLiffInit(true)
          onLiffInitialed()
        })
        .catch((err) => {
          console.log('LIFF initialed error: ', err.code, err.message)
          !isDevelopment &&
            Sentry.withScope((scope) => {
              scope.setTag('LIFF Error Code', err.code)
              Sentry.captureException(new Error(`LIFF initialed error : ${err.code} -> ${err.message}`))
            })
        })
    }
  }, [isFacebookWebviewInit, liffId])

  return false
}

export default useGetLiffUser
